import { createFileRoute } from '@tanstack/react-router';
import { DigitalWalletTokenPage } from '../components/pages/DigitalWalletTokenPage/DigitalWalletTokenPage';

export const Route = createFileRoute('/account/dwt_/$tokenId')({
  component: DigitalWalletTokenPage,
});
